module.exports = __webpack_public_path__ + "assets/textarea.6a19873e.svg";